//import React, { Component, useRef } from 'react';
import React, { Component } from 'react';
import Grid from "@material-ui/core/Grid";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from "@material-ui/core/Button";
import MaterialTable from 'material-table';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import 'moment-timezone';
import moment from 'moment'

export class UsersPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            selecteduserid: "",

            usersUsername: "",
            usersName: "",
            usersSurname: "",
            usersEmail: "",
            usersPhone: "",
            usersPermission: "",
            usersPassword: "",

            usersUsernameCreate: "",
            usersNameCreate: "",
            usersSurnameCreate: "",
            usersEmailCreate: "",
            usersPhoneCreate: "",
            usersPermissionCreate: "",
            usersPasswordCreate: "",

            usersUsernameUpdate: "",
            usersNameUpdate: "",
            usersSurnameUpdate: "",
            usersEmailUpdate: "",
            usersPhoneUpdate: "",
            usersPermissionUpdate: "",
            usersPasswordUpdate: "",
            isLoginCredentialsSoftDeleted: -1,

            loading: true,
            notAuthorized: true,

            isFetching: false,

            isMailSendChecked: true,

            userType: -1,
        }

        this.refUserUpdate = React.createRef();
    }

    componentDidMount() {
        this.loadUsers();
        this.getUserType();
    }

    handleChange = async (e) => {
        //console.log(e);
        console.log(e.target.name + " " + e.target.value);
        e.persist();
        await this.setState({ [e.target.name]: e.target.value });
    };

    handleChangeTitleCase = async (e) => {
        //console.log(e);
        console.log(e.target.name + " " + e.target.value);
        e.persist();
        await this.setState({
            [e.target.name]: e.target.value
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')
        });
    };

    handleChangeIntegerOnly = async (e) => {
        //console.log(e);
        console.log(e.target.name + " " + e.target.value);
        e.persist();
        await this.setState({ [e.target.name]: e.target.value.replace(/\D/, '') });
    };

    handleChangePhone = async (e) => {
        //console.log(e);
        console.log(e.target.name + " " + e.target.value);
        e.persist();

        if (e.target.value.length <= 14) {
            await this.setState({ [e.target.name]: e.target.value.replace(/\D/, '') });
        }
    };

    handleChangeDate = (name, value) => {
        //console.log(name);
        //console.log(value);

        //this.setState({ [name]: new Date(value) });
        this.setState({ [name]: new Date(moment(value).format('YYYY-MM-DD')) });
    };

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleCheckChange = (e) => {
        this.setState({ isMailSendChecked: e.target.checked });
        console.log(this.state.isMailSendChecked);
    };

    loadUsers = async () => {

        await fetch(global.variables.API_USEROPERATIONS_LOADALLUSERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 2) {
                    this.setState({
                        loading: false,
                        notAuthorized: true
                    });
                } else {
                    this.setState({
                        users: result.listofusers,
                        loading: false,
                        notAuthorized: false
                    });
                }
            });
    };

    getUserType = () => {
        let pageData = {
            operation: "GetUserType"
        };

        fetch(global.variables.API_USEROPERATIONS_GETUSERTYPE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ userType: result.userType });
            });
    }

    createUser = async () => {

        if (this.state.usersPermissionCreate > 0) {

        } else {

            toast.error("You must select a permission level!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            return;
        }

        if (this.state.usersEmailCreate.indexOf("@") === -1) {

            toast.error("Please input a valid email address!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            return;
        }

        await this.setState({ isFetching: true });

        await fetch(global.variables.API_USEROPERATIONS_CREATEUSER, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadUsers();
            });

        await this.setState({ isFetching: false });
    };

    updateUser = async () => {

        await this.setState({ isFetching: true });

        await fetch(global.variables.API_USEROPERATIONS_UPDATEUSER, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }

                this.loadUsers();
            });

        await this.setState({ isFetching: false });
    };

    handleSetUpdateFields = (userId) => {

        //console.log(this.state);

        for (var i = 0; i < this.state.users.length; i++) {
            if (this.state.users[i].idLoginCredentials === userId) {
                this.setState({
                    usersIdLoginCredentials: userId,
                    usersNameUpdate: this.state.users[i].LoginName,
                    usersSurnameUpdate: this.state.users[i].LoginSurname,
                    usersUsernameUpdate: this.state.users[i].LoginUsername,
                    usersEmailUpdate: this.state.users[i].LoginEmail,
                    usersPhoneUpdate: this.state.users[i].LoginPhoneNumber,
                    usersPermissionUpdate: this.state.users[i].UserType,
                    isLoginCredentialsSoftDeleted: this.state.users[i].isLoginCredentialsSoftDeleted
                });

                //const vrefUserUpdate = ReactDOM.findDOMNode(this.refs.refUserUpdate);
                //window.scrollTo(0, vrefUserUpdate.current.offsetTop);
                window.scrollTo(0, this.refUserUpdate.current.offsetTop);
            }
        }
    }

    returnArrayElement = (array, element) => {

        if (this.state.userType === 4 &&
            (element === this.state.usersPermissionCreate ||
                element === this.state.usersPermissionUpdate)) {

            return ({ TypeId: 4, TypeName: "Key Partners (EUD, CFCU, DEUA)" });

        } else {

            for (var i = 0; i < array.length; i++) {
                if (array[i].TypeId === element) {
                    return array[i];
                }
            }

            return ({ TypeId: "", TypeName: "" });
        }
    };

    render() {

        var userPermissionOptions = [
            { TypeId: 1, TypeName: "Administrator" },
            { TypeId: 2, TypeName: "Mission Coordinator" },
            //{ TypeId: 3, TypeName: "ROMIS User (Expert, QC, QA)" },
            { TypeId: 3, TypeName: "Experts (ROM, QC, QA)" },
            { TypeId: 4, TypeName: "Key Partners (EUD, CFCU, DEUA)" }
        ];

        var userStatusOptions = [
            { TypeId: 0, TypeName: "Active" },
            { TypeId: 1, TypeName: "Inactive" }
        ];

        const {
            //users,
            //selecteduserid,

            //usersUsername,
            //usersName,
            //usersSurname,
            //usersEmail,
            //usersPhone,
            //usersPermission,
            //usersPassword,

            //usersUsernameCreate,
            usersNameCreate,
            usersSurnameCreate,
            usersEmailCreate,
            usersPhoneCreate,
            usersPermissionCreate,
            usersPasswordCreate,

            //usersUsernameUpdate,
            usersNameUpdate,
            usersSurnameUpdate,
            usersEmailUpdate,
            usersPhoneUpdate,
            usersPermissionUpdate,
            usersPasswordUpdate,
            isLoginCredentialsSoftDeleted,

            isFetching,

            isMailSendChecked,

            userType,

        } = this.state;

        if (this.state.loading) {
            return (
                <Grid container spacing={3} >
                    <Grid item xs={12} className="mt-2" style={{ textAlign: "center", display: this.state.loading ? "block" : "none" }}>
                        <CircularProgress /> Loading...
                    </Grid>
                </Grid>
            );
        } else if (this.state.notAuthorized) {
            return (
                <p>You are not authorized</p>
            );
        } else {
            return (
                <Grid container spacing={3} >
                    <Grid>
                        <ToastContainer />
                    </Grid>
                    <Grid item xs={6} height="100%">
                        <Card>
                            <CardHeader title="New User Details" className='romis-card-header' />
                            <CardContent>
                                <TextField
                                    label="Name : *"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChangeTitleCase}
                                    value={usersNameCreate}
                                    name="usersNameCreate"
                                />
                                <TextField
                                    label="Surname : *"
                                    placeholder="Surname"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChangeTitleCase}
                                    value={usersSurnameCreate}
                                    name="usersSurnameCreate"
                                />
                                <TextField
                                    label="Email : *"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChange}
                                    value={usersEmailCreate}
                                    name="usersEmailCreate"
                                />
                                <TextField
                                    label="Phone :"
                                    placeholder="Phone"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChangePhone}
                                    value={usersPhoneCreate}
                                    name="usersPhoneCreate"
                                />
                                <TextField
                                    label="Password :"
                                    placeholder="Password"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChange}
                                    value={usersPasswordCreate}
                                    name="usersPasswordCreate"
                                    disabled
                                    style={{ display: "none" }}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={6} height="100%">
                        <Card>
                            <CardHeader title="New User Permission Level" className='romis-card-header' />
                            <CardContent>
                                <Autocomplete
                                    options={userPermissionOptions}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => { this.handleSelectChange(e, v, "usersPermissionCreate") }}
                                    value={this.returnArrayElement(userPermissionOptions, usersPermissionCreate)}
                                    renderInput={params => (
                                        <TextField {...params} label="Permission Level *" margin="normal" fullWidth />
                                    )}
                                    disabled={userType === 4 ? true : false}
                                />

                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={isMailSendChecked}
                                                onChange={this.handleCheckChange.bind(this)}
                                                color="primary"
                                                name="mailsendcheck"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />
                                        }
                                        label="Send password creation link via email"
                                    />
                                </FormGroup>

                                {
                                    //<Checkbox
                                    //    defaultChecked
                                    //    inputProps={{ 'aria-label': 'primary checkbox' }}
                                    ///>
                                    //<TextField
                                    //    label="Permission Type :"
                                    //    placeholder="Permission Type"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={usersPermission}
                                    //    name="usersPermission"
                                    ///>
                                }
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} height="100%">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.createUser}
                            fullWidth
                            disabled={isFetching ? true : false}
                        >
                            Create New User
                        </Button>
                    </Grid>





                    <Grid item xs={12} height="100%">
                        <Card>
                            <CardHeader title="Update User" className='romis-card-header' />
                            <CardContent>

                                <MaterialTable
                                    columns={[
                                        { title: 'User Id', field: 'idLoginCredentials', hidden: true },
                                        { title: 'Name', field: 'LoginName' },
                                        { title: 'Surname', field: 'LoginSurname' },
                                        { title: 'Mail Address', field: 'LoginEmail' },
                                        { title: 'Telephone Number', field: 'LoginPhoneNumber' },
                                        { title: 'Permission Level', field: 'UserTypeName' },
                                        { title: 'Status', field: 'UserStatusName' },
                                    ]}
                                    data={this.state.users}
                                    title="Users"
                                    actions={[
                                        //{
                                        //    icon: 'info',
                                        //    tooltip: 'Project Details',
                                        //    onClick: (event, rowData) => {
                                        //        this.props.history.push(`/projectdetails/${rowData.idProjectDetails}`);
                                        //    },
                                        //},
                                        {
                                            icon: 'info',
                                            tooltip: 'Edit User',
                                            onClick: (event, rowData) => {
                                                //this.props.history.push(`/missiondetails/${rowData.idMissionDetails}`);
                                                //this.setState({ selecteduserid: `${rowData.idLoginCredentials}` });
                                                this.handleSetUpdateFields(`${rowData.idLoginCredentials}`);
                                            },
                                        },
                                    ]}
                                    options={{
                                        actionsColumnIndex: -1
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </Grid>


                    <Grid item xs={6} height="100%" ref={this.refUserUpdate}>
                        <Card>
                            <CardHeader title="User Details" className='romis-card-header' />
                            <CardContent>
                                <TextField
                                    label="Name : *"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChangeTitleCase}
                                    value={usersNameUpdate}
                                    name="usersNameUpdate"
                                />
                                <TextField
                                    label="Surname : *"
                                    placeholder="Surname"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChangeTitleCase}
                                    value={usersSurnameUpdate}
                                    name="usersSurnameUpdate"
                                />
                                <TextField
                                    label="Email : *"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChange}
                                    value={usersEmailUpdate}
                                    name="usersEmailUpdate"
                                />
                                <TextField
                                    label="Phone :"
                                    placeholder="Phone"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChangePhone}
                                    value={usersPhoneUpdate}
                                    name="usersPhoneUpdate"
                                />
                                <TextField
                                    label="Password :"
                                    placeholder="Password"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChange}
                                    value={usersPasswordUpdate}
                                    name="usersPasswordUpdate"
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={6} height="100%">
                        <Card>
                            <CardHeader title="Permissions" className='romis-card-header' />
                            <CardContent>
                                <Autocomplete
                                    options={userPermissionOptions}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => { this.handleSelectChange(e, v, "usersPermissionUpdate") }}
                                    value={this.returnArrayElement(userPermissionOptions, usersPermissionUpdate)}
                                    renderInput={params => (
                                        <TextField {...params} label="Permission Level *" margin="normal" fullWidth />
                                    )}
                                    disabled={userType === 4 ? true : false}
                                />
                                <Autocomplete
                                    options={userStatusOptions}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => { this.handleSelectChange(e, v, "isLoginCredentialsSoftDeleted") }}
                                    value={this.returnArrayElement(userStatusOptions, isLoginCredentialsSoftDeleted)}
                                    renderInput={params => (
                                        <TextField {...params} label="Status *" margin="normal" fullWidth />
                                    )}
                                />
                                {
                                    //<TextField
                                    //    label="Permission Type :"
                                    //    placeholder="Permission Type"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={usersPermission}
                                    //    name="usersPermission"
                                    ///>
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} height="100%">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.updateUser}
                            fullWidth
                        >
                            Update User
                    </Button>
                    </Grid>
                </Grid>
            );
        }
    }
}





// WEBPACK FOOTER //
// ./src/pages/UsersPage.js